module.exports = __webpack_public_path__ + "img/W-S32.5072d422.jpg";